import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { API } from "../lib/site";
import { LogoMark } from "./Logo";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: r.data }, replace: true });
      })
      .catch((err) => {
        const detail = err.response?.data?.detail;
        toast.error(typeof detail === "string" ? detail : "Google sign-in failed. Please try again.");
        navigate("/admin", { replace: true });
      });
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-950" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-5">
        <LogoMark className="h-16 w-auto" dark />
        <Loader2 className="h-6 w-6 animate-spin text-gold-400" />
        <p className="text-sm tracking-wide text-white/60">Signing you in with Google…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
